import { getV3ColorCssVariable } from '../colors_v3'

const BaseButtonThemes = {
  light: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade2'),
        backgroundColor: getV3ColorCssVariable('shades', 'white'),
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        hover: getV3ColorCssVariable('shades', 'shade6'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        backgroundColor: getV3ColorCssVariable('shades', 'white'),
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        hover: getV3ColorCssVariable('shades', 'shade5'),
      },
    },
  },
  dark: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('shades', 'shade2'),
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade4'),
        hover: getV3ColorCssVariable('shades', 'shade6'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade4'),
        backgroundColor: getV3ColorCssVariable('shades', 'shade2'),
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade4'),
        hover: getV3ColorCssVariable('shades', 'shade4'),
      },
    },
  },
  transparent: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: 'transparent',
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade4'),
        hover: getV3ColorCssVariable('shades', 'shade5'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        backgroundColor: 'transparent',
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        hover: getV3ColorCssVariable('shades', 'shade5'),
      },
    },
  },
  'transparent-light': {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: 'transparent',
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'white'),
        hover: getV3ColorCssVariable('shades', 'shade5'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        backgroundColor: 'transparent',
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        hover: getV3ColorCssVariable('shades', 'shade5'),
      },
    },
  },
  'transparent-dark': {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade2'),
        backgroundColor: 'transparent',
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        hover: getV3ColorCssVariable('shades', 'shade6'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        backgroundColor: 'transparent',
      },
      borderColors: {
        default: getV3ColorCssVariable('shades', 'shade5'),
        hover: getV3ColorCssVariable('shades', 'shade5'),
      },
    },
  },
  primary: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('primary', 'default'),
      },
      borderColors: {
        default: getV3ColorCssVariable('primary', 'light'),
        hover: getV3ColorCssVariable('shades', 'shade8'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('primary', 'washed'),
      },
      borderColors: {
        default: getV3ColorCssVariable('primary', 'washed'),
        hover: getV3ColorCssVariable('primary', 'washed'),
      },
    },
  },
  secondary: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('secondary', 'default'),
      },
      borderColors: {
        default: getV3ColorCssVariable('secondary', 'light'),
        hover: getV3ColorCssVariable('secondary', 'light'),
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('secondary', 'washed'),
      },
      borderColors: {
        default: getV3ColorCssVariable('secondary', 'washed'),
        hover: getV3ColorCssVariable('secondary', 'washed'),
      },
    },
  },
  warning: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('status', 'warning'),
      },
      borderColors: {
        default: 'transparent',
        hover: 'transparent',
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('transparentStatus', 'warning'),
      },
      borderColors: {
        default: 'transparent',
        hover: 'transparent',
      },
    },
  },
  invalid: {
    active: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('status', 'invalid'),
      },
      borderColors: {
        default: 'transparent',
        hover: 'transparent',
      },
    },
    disabled: {
      colors: {
        default: getV3ColorCssVariable('shades', 'white'),
        backgroundColor: getV3ColorCssVariable('transparentStatus', 'invalid'),
      },
      borderColors: {
        default: 'transparent',
        hover: 'transparent',
      },
    },
  },
}

export default BaseButtonThemes
